import type {useTranslations} from 'next-intl';
import {z} from 'zod';
import {checkIsPhone} from '@/entities/Auth/helpers/checkIsPhone';
import {isEmail} from '../helpers/isEmail';

/**
 * @description Схема валидации формы логина для email
 */
export const loginEmailSchema = (t: ReturnType<typeof useTranslations>) =>
  z.object({
    email: z
      .string()
      .trim()
      .min(1, {message: t('Errors.InputEmail')})
      .refine(val => isEmail(val), {
        message: t('Errors.EnterValidEmail'),
      }),
    password: z.string().min(1, {message: t('Errors.InputPassword')}),
  });

/**
 * @description Схема валидации формы логина для телефона
 * Более гибкая валидация - принимает любой телефон с 7-15 цифрами
 */
export const loginPhoneSchema = (t: ReturnType<typeof useTranslations>) =>
  z.object({
    phone: z
      .string()
      .trim()
      .min(1, {message: t('Errors.InputPhone')})
      .refine(
        val => {
          const digits = val.replace(/\D/g, '');
          return digits.length >= 11 && digits.length <= 15;
        },
        {
          message: t('Errors.EnterValidPhone'),
        },
      ),
    password: z.string().min(1, {message: t('Errors.InputPassword')}),
  });

/**
 * @description Схема валидации формы логина: обязательные поля, email ИЛИ телефон
 * @deprecated Использовать loginEmailSchema или loginPhoneSchema
 */
export const loginSchema = (t: ReturnType<typeof useTranslations>) =>
  z.object({
    emailOrPhone: z
      .string()
      .trim()
      .min(1, {message: t('Errors.InputEmailOrPhone')})
      .refine(val => isEmail(val) || checkIsPhone(val), {
        message: t('Errors.EnterValidEmailOrPhone'),
      }),
    password: z.string().min(1, {message: t('Errors.InputPassword')}),
  });
